import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface ProjectBannerProps {
    projectInfo: any;
}

const ProjectBanner: React.FC<ProjectBannerProps> = ({ projectInfo }) => {
    if (!projectInfo || !projectInfo.banner_enabled || !projectInfo.banner_text) {
        return null;
    }
    return (
        <div className="bg-plot-blue text-white p-2 flex flex-row">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
            <div className="banner-text">{projectInfo.banner_text}</div>
        </div>
    );
};

export default ProjectBanner;
